import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routeLabels: { [key: string]: string } = {
  'home': 'Home',
  'about': 'About',
  'team': 'Our Team',
  'partners': 'Partners',
  'careers': 'Careers',
  'faqs': 'FAQs',
  'capabilities': 'Capabilities',
  'climate-finance': 'Climate Finance',
  'energy-finance': 'Energy Finance',
  'biodiversity-finance': 'Biodiversity Finance',
  'research': 'Research',
  'insights': 'Insights',
  'news': 'News',
  'events': 'Events',
  'contact': 'Contact',
  'programs': 'Programs',
  'cafp': 'Climate Adaptation Finance Program'
};

export default function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Don't show breadcrumbs on home page
  if (pathnames.length === 0 || pathnames[0] === 'home') {
    return null;
  }

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="bg-gray-50 border-b border-gray-200 mt-16 mb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-12">
          <ol className="flex items-center space-x-2 text-sm">
            <li>
              <Link
                to="/home"
                onClick={handleScrollToTop}
                className="text-gray-500 hover:text-gray-700 flex items-center"
              >
                <Home className="h-4 w-4" />
              </Link>
            </li>
            {pathnames.map((name, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join('/')}#top`;
              const isLast = index === pathnames.length - 1;

              return (
                <li key={name} className="flex items-center">
                  <ChevronRight className="h-4 w-4 text-gray-400 mx-1" />
                  {isLast ? (
                    <span className="text-green-600 font-medium">
                      {routeLabels[name] || name}
                    </span>
                  ) : (
                    <Link
                      to={routeTo}
                      onClick={handleScrollToTop}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      {routeLabels[name] || name}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </nav>
  );
}